import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { CicBundleType, CicChangeRemovalCause } from 'constants/cicReason';

export const CIC_HISTORY_TITLE = 'CIC History';

export const CIC_HISTORY_DESCRIPTION = 'Loan-term and fee changes of circumstance.';

export const LOAD_ERROR_MESSAGE = "Couldn't load the CIC history.";

export const RETRY_BUTTON_LABEL = 'Try again';

export const EMPTY_HISTORY_MESSAGE =
  'No changes of circumstance have been recorded on this loan yet.';

export const CicDisclosureFilter = {
  ALL: 'All',
  ...CicBundleType,
};

export const CicBundleChipTitle = {
  [CicBundleType.CIC_LE]: 'CIC LE',
  [CicBundleType.CIC_CD]: 'CIC CD',
};

export const CIC_DISCLOSURE_FILTER_BUTTONS = [
  { value: CicDisclosureFilter.ALL, label: 'All' },
  { value: CicDisclosureFilter.CIC_LE, label: CicBundleChipTitle[CicBundleType.CIC_LE] },
  { value: CicDisclosureFilter.CIC_CD, label: CicBundleChipTitle[CicBundleType.CIC_CD] },
];

export const CicDisclosureTitle = {
  [CicBundleType.CIC_LE]: 'Revised Loan Estimate',
  [CicBundleType.CIC_CD]: 'Revised Closing Disclosure',
};

export const CicNextDisclosureTitle = {
  [CicBundleType.CIC_LE]: 'Next Revised LE',
  [CicBundleType.CIC_CD]: 'Next Revised CD',
};

export const CicDisclosureShortName = {
  [CicBundleType.CIC_LE]: 'LE',
  [CicBundleType.CIC_CD]: 'CD',
};

export const DISCLOSURE_SHORT_NAME_FALLBACK = 'disclosure';

export const CicRemovalCauseLabel = {
  [CicChangeRemovalCause.SUPERSEDED_BY_LATER_CHANGE]: 'Superseded by a later change to this field',
  [CicChangeRemovalCause.VALUE_REVERTED]: 'Value reverted before send',
  [CicChangeRemovalCause.GROUP_CANCELLED_BY_MANUAL_UPLOAD]:
    'Superseded by a manually uploaded disclosure',
};

export const PENDING_DISCLOSURE_CHIP_TITLE = 'Pending disclosure';

export const WINDOW_CLOSES_LABEL = 'Aggregation window closes';

export const WINDOW_CLOSED_LABEL = 'Aggregation window closed';

export const SENT_DISCLOSURES_TITLE = 'Sent CIC disclosures';

export const NO_SENT_DISCLOSURES_MESSAGE = 'No CIC LE or CD has been sent on this loan yet.';

export const NO_FILTERED_DISCLOSURES_MESSAGE = 'No disclosures of this type have been sent.';

export const CHANGES_CARRIED_TITLE = 'Changes carried';

export const DISCLOSED_CHIP_TITLE = 'Disclosed';

export const REMOVED_AT_AGGREGATION_TITLE = 'Removed at aggregation';

export const NOT_DISCLOSED_CHIP_TITLE = 'Not disclosed';

export const REMOVED_DESCRIPTION = 'Kept for audit; never in document dynamic fields';

export const UNATTACHED_REMOVED_TITLE = 'Removed without a disclosure';

export const UNATTACHED_REMOVED_DESCRIPTION =
  'Recorded changes that no CIC disclosure went out for, e.g. a window whose values were all typed back';

export const NO_CARRIED_CHANGES_MESSAGE = 'No per-field reasons were recorded for this disclosure.';

export const FEE_CHANGES_TITLE = 'Fee changes';

export const FEE_CHANGES_CARRIED_TITLE = 'Fee changes carried';

export const UNATTACHED_FEE_CHANGES_TITLE = 'Fee changes disclosed on other disclosures';

export const UNATTACHED_FEE_CHANGES_DESCRIPTION =
  'Disclosed fee changes that no CIC disclosure listed above carried, e.g. ones sent on a non-CIC Closing Disclosure';

export const EARLIER_REASONS_TITLE = 'Earlier reasons';

export const EARLIER_REASONS_DESCRIPTION = 'Recorded before per-field capture';

export const EDIT_BUTTON_LABEL = 'Edit';

export const EDITED_CHIP_TITLE = 'Edited';

export const NO_ITEMS = [];

const FormDeliveryStatusPrefix = {
  IN_PROGRESS_AFTER_ACKNOWLEDGING: 'InProgress.AfterAcknowledging',
  IN_PROGRESS: 'InProgress',
  COMPLETED_ON_SIGNING: 'Completed.OnSigning',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

export const NEXT_DISCLOSURE_FALLBACK_TITLE = 'Next revised disclosure';

export const NO_PENDING_CHANGES_MESSAGE = 'No changes are waiting for this disclosure yet.';

export const EDIT_REASON_DIALOG_SIZE = '680px';

export const REASON_UPDATED_MESSAGE = 'CIC reason updated';

export const EDIT_HISTORY_TITLE = 'Edit history';

export const ReasonEditKind = {
  ORIGINAL_REPLACED: 'OriginalReplaced',
  REASON_CHANGED: 'ReasonChanged',
  COMMENT_CHANGED: 'CommentChanged',
};

export const DELIVERY_STATUS_LABELS = [
  {
    prefix: FormDeliveryStatusPrefix.IN_PROGRESS_AFTER_ACKNOWLEDGING,
    label: { title: 'Acknowledged', variant: LabelVariant.GREEN },
  },
  {
    prefix: FormDeliveryStatusPrefix.IN_PROGRESS,
    label: { title: 'Sent', variant: LabelVariant.BLUE },
  },
  {
    prefix: FormDeliveryStatusPrefix.COMPLETED_ON_SIGNING,
    label: { title: 'Signed', variant: LabelVariant.GREEN },
  },
  {
    prefix: FormDeliveryStatusPrefix.COMPLETED,
    label: { title: 'Delivered', variant: LabelVariant.GREEN },
  },
  {
    prefix: FormDeliveryStatusPrefix.CANCELLED,
    label: { title: 'Canceled', variant: LabelVariant.GRAY },
  },
];

export const UNKNOWN_DELIVERY_STATUS_LABEL = { title: 'Unknown', variant: LabelVariant.GRAY };
